import {LocalStorageObject} from '../Utilities';

export class SessionDTO implements LocalStorageObject {
  public session: string | null = null;

  fromStorage(data: any) {
    this.session = data.session;
    return this;
  }
}
